module.exports = __webpack_public_path__ + "static/media/Icon2.504faab7.png";